import "../../css/404.css";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
const Page404 = () => {
  return (
    <div className="not-found-container">
      <ErrorOutlineIcon className="not-found-icon" />
      <h1>404 - Page Not Found</h1>
      <p>The page you’re looking for doesn’t exist.</p>
      <a href="/" className="back-home">
        Go Back Home
      </a>
    </div>
  );
};

export default Page404;
